module.exports = __webpack_public_path__ + "img/menu.ef0c5663.svg";